<template>
  <tr @keyup.enter="filterChanged">
    <template v-for="(column, index) in columns">
      <th class="input-wrapper cursor-pointer" v-if="filterComputed[column.value]" :key="index">
        <b-input-group
            v-if="filterComputed[column.value].filter.type === 'input' || filterComputed[column.value].filter.type === '' || filterComputed[column.value].filter.type === undefined">
          <b-form-input
              v-if="filterComputed[column.value].filter.type === 'input' || filterComputed[column.value].filter.type === '' || filterComputed[column.value].filter.type === undefined"
              v-model="filterValues[filter[filterComputed[column.value].index].name]"
              :placeholder="filterComputed[column.value].filter.realName ? filterComputed[column.value].filter.realName : filterComputed[column.value].filter.name"
          ></b-form-input>
          <b-input-group-append is-text>
            <input type="checkbox" v-model="filterExact" :value="filter[filterComputed[column.value].index].name"
                   content="Exact phrase" v-tippy="{arrow : true}" aria-label="Exact phrase">
          </b-input-group-append>
        </b-input-group>
        <b-form-select
            v-if="filterComputed[column.value].filter.type === 'select'"
            v-model="filterValues[filter[filterComputed[column.value].index].name]"
            :options="filterComputed[column.value].filter.options"
            @change="filterChanged()"
            placeholder="ANY"></b-form-select>
        <button
            v-if="filterComputed[column.value].filter.type === 'button'"
            class="btn btn-primary btn-filter"
            :class="{'implemented':buttonCheck(filterComputed[column.value].filter.filter)}"
        >{{ filterComputed[column.value].filter.value }}
        </button>
      </th>
      <th v-else-if="column.value === 'CRUD'" :key="index" class="d-flex">
        <div class="selected-items" v-if="itemsSelectedCount > 0">
          <button class="btn btn-default delete-btn small icon-only"
                  @click="actionDelete()">
            <span class="selected-items-count">({{ itemsSelectedCount }}) </span>
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </th>
      <th v-else :key="index"></th>
      <th v-if="lastFilter === column.value && column.value !== 'CRUD'" :key="index">
        <span class="cel-buttons">
          <span class="icon-search" @click="filterChanged()" title="Apply filters"><i class="fa fa-solid fa-search"></i></span>
           <span class="icon-clear" @click="clearFilter()" title="Clear filters">
            <font-awesome-icon icon="recycle" class="icon alt"/>
           </span>
        </span>
      </th>
    </template>

  </tr>
</template>
<script>
function debounce(that, fn, delay) {
  let timeoutID = undefined;
  return () => {
    clearTimeout(timeoutID);
    const args = arguments;
    timeoutID = setTimeout(() => {
      fn.apply(that, args);
    }, delay);
  };
}

import _ from "lodash"

export default {
  name: "listFiltersV2",
  emits: ['deleteItems', 'onChanged', 'changeTitle'],
  props: {
    filterExact: {
      type: Array,
      default: []
    },
    itemsSelectedCount: {
      type: Number,
      default: 0
    },
    title: String,
    result: Array,
    filter: {
      type: Array,
      default: function () {
        return {
          name: 'Name',
          value: '',
          w: 100
        }
      }
    },
    columns: {
      type: Array,
      default: () => {
        return [
          {
            name: '',
            value: '',
          }
        ]
      }
    },
    filterValues: {
      type: Object,
      default: function () {
        return {
          Name: '',
        }
      }
    }
  },
  data() {
    return {
      filters: [],
      queryFilter: [],
      filterWithColumns: [],
      newFilters: [],
    };
  },
  methods: {
    actionDelete() {
      this.$emit('deleteItems')
    },

    filterChanged() {
      this.debounced();
    },
    getUnnamedFilter(data) {
      let condition;
      let field;
      let value;
      if (Object.prototype.hasOwnProperty.call(data, 'Data') &&
          Object.prototype.hasOwnProperty.call(data, 'Condition')) {
        condition = data['Condition'];
        field = Object.keys(data['Data'])[0];
        value = data['Data'][field];
      }
      let fieldExist = false;
      for (let filterIndex in this.filter) {
        if (Object.prototype.hasOwnProperty.call(this.filter[filterIndex], 'name')) {
          if (field == this.filter[filterIndex].name) {
            fieldExist = true;
          }
        }
      }
      if (!fieldExist) {
        return ' ' + field + ' ' + condition + ' ' + value;
      }
      return '';
    },
    buttonFilter(filterConfig) {
      if (Object.keys(filterConfig || {}).length === 0) {
        return
      }
      if (!this.buttonCheck(filterConfig)) {
        this.pushFilters(filterConfig);
      } else {
        this.popFilters(filterConfig);
      }
      this.filterSend();
    },
    buttonCheck(filterConfig) {
      let keyCount = Object.keys(filterConfig || {}).length
      if (keyCount === 0) {
        return true;
      }
      let keyAlignmentCount = 0;
      for (let filterIdx in filterConfig) {
        let data = {};
        if (!filterConfig[filterIdx].Data || !filterConfig[filterIdx].Condition) {
          return true;
        }
        let field;
        let value;
        for (let fieldName in filterConfig[filterIdx].Data) {
          field = fieldName;
          value = filterConfig[filterIdx].Data[fieldName];
        }
        data[field] = value;

        for (let filterUsedIdx in this.filters) {
          let fieldUsed;
          let valueUsed;
          if (!this.filters[filterUsedIdx]) continue;
          if (this.filters[filterUsedIdx] == undefined) {
            console.log("WTF");
          }
          for (let fieldName in this.filters[filterUsedIdx].Data) {
            fieldUsed = fieldName;
            valueUsed = this.filters[filterUsedIdx].Data[fieldName];
          }
          if (this.filters[filterUsedIdx].Condition === filterConfig[filterIdx].Condition &&
              fieldUsed == field && value == valueUsed) {
            keyAlignmentCount++;
          }
        }
      }
      if (keyCount === keyAlignmentCount) {
        return true;
      }
      return false;
    },
    pushFilters(filterConfig) {
      for (let filterIdx in filterConfig) {
        if (!filterConfig[filterIdx].Data || !filterConfig[filterIdx].Condition) {
          continue;
        }
        let field;
        let value;
        for (let fieldName in filterConfig[filterIdx].Data) {
          field = fieldName;
          value = filterConfig[filterIdx].Data[fieldName];
        }
        if (value) {
          this.filterValues[field] = value;
        }
      }
    },
    popFilters(filterConfig) {
      let filterCopy = [];
      for (let filterIdx in filterConfig) {
        let data = {};
        if (!filterConfig[filterIdx].Data || !filterConfig[filterIdx].Condition) {
          return true;
        }
        let field;
        let value;
        for (let fieldName in filterConfig[filterIdx].Data) {
          field = fieldName;
          value = filterConfig[filterIdx].Data[fieldName];
        }
        if (Object.keys(this.filterValues).includes(field)) {
          this.filterValues[field] = '';
        }
        data[field] = value;
        let filterExist = false;
        let lastFilterItem = {};
        for (let filterUsedIdx in this.filters) {
          let fieldUsed;
          let valueUsed;
          if (!this.filters[filterUsedIdx]) continue;
          if (this.filters[filterUsedIdx] === undefined) {
            console.log("WTF");
          }
          for (let fieldName in this.filters[filterUsedIdx].Data) {
            fieldUsed = fieldName;
            valueUsed = this.filters[filterUsedIdx].Data[fieldName];
          }
          if (this.filters[filterUsedIdx].Condition !== filterConfig[filterIdx].Condition &&
              fieldUsed != field && value != valueUsed) {
            filterExist = true;
            lastFilterItem = this.filters[filterUsedIdx];
          }
        }
        if (filterExist) {
          filterCopy.push(lastFilterItem);
          this.filterValues[field] = value;
        }
      }
      this.filters = filterCopy;
    },
    onRouteChange() {
      this.queryFilter = [];
      this.filters = [];
      this.filterQuery();
      this.$emit('onInit', this.filters);
    },
    filterQuery() {
      if (!this.$route.query.filter) {
        return;
      }
      this.queryFilter = JSON.parse(this.$route.query.filter);
      if (this.queryFilter.length == 0) {
        return;
      }
      if (this.queryFilter) {
        if (Object.keys(this.queryFilter || {}).length === 0) {
          for (let FieldName in this.filterValues) {
            this.filterValues[FieldName] = '';
          }
        }
        for (let filterIdx in this.queryFilter) {
          let data = {};
          if (!this.queryFilter[filterIdx].Data || !this.queryFilter[filterIdx].Condition) {
            continue;
          }
          let condition = this.queryFilter[filterIdx].Condition;
          let field;
          let value;
          for (let fieldName in this.queryFilter[filterIdx].Data) {
            field = fieldName;
            value = this.queryFilter[filterIdx].Data[fieldName];
          }
          if (value !== null && value !== undefined) {
            this.filterValues[field] = value;
          }
          data[field] = value;
          if (condition === '=') {
            this.filterExact.push(field)
          }
          this.filters.push({
            Condition: condition,
            Data: data,
          });
        }
      }
    },
    clearFilter() {
      for (let FieldName in this.filterValues) {
        this.filterValues[FieldName] = '';
      }
      this.filters = [];
      this.queryFilter = [];
      this.$route.query.filter;
      this.filterChanged();
    },
    filterSend() {
      let currentQuery = this.$route.query;
      this.newFilters = [];
      for (let FieldName in this.filterValues) {
        if (this.filterValues[FieldName] != '') {
          let data = {};
          data[FieldName] = this.filterValues[FieldName];
          if (this.filterExact.includes(FieldName)) {
            this.newFilters.push({
              Condition: "=",
              Data: data,
            });
          } else {
            this.newFilters.push({
              Condition: "ilike",
              Data: data,
            });
          }
        }
      }
      if (JSON.stringify(currentQuery) !== JSON.stringify({filter: JSON.stringify(this.newFilters)})) {
        this.$router.push({query: {filter: JSON.stringify(this.newFilters)}});
      } else {
        console.log('Filter error: filter duplicate')
      }
    },
  },
  watch: {
    '$route': 'onRouteChange',
    queryFilter: function (val) {
      const $this = this
      if (!_.isEqual(val, this.newFilters)) {
        let title = this.title + ' for: '
        _.forEach(val, function (field) {
          title += $this.getUnnamedFilter(field)
        })
        this.$emit('changeTitle', title)
        this.$emit('onChanged', val)
      }
    }
  },
  created: function () {
    this.filterQuery();
    this.$emit('onInit', this.filters);
    this.debounced = debounce(this, this.filterSend, 200);
  },
  computed: {
    filterComputed: function () {
      let filters = {}
      this.columns.map((column) => {
        let index = this.filter.findIndex(f => f.name.toLowerCase() === column.value.toLowerCase() || (f.showInColumn && f.showInColumn.toLowerCase() === column.value.toLowerCase()) || (f.realName && f.realName.toLowerCase() === column.value.toLowerCase()))
        if (index >= 0) {
          filters[column.value] = {filter: {...this.filter[index]}, index}
          this.filterWithColumns.push(index)
        } else {
          index = this.filter.findIndex(f => f.name.toLowerCase() === column.name.toLowerCase() || (f.showInColumn && f.showInColumn.toLowerCase() === column.name.toLowerCase()) || (f.realName && f.realName.toLowerCase() === column.name.toLowerCase()))
          if (index >= 0) {
            filters[column.value] = {filter: {...this.filter[index]}, index}
            this.filterWithColumns.push(this.filter[index].name)
          }
        }

        if (column.value.toLowerCase() === 'entity' && index >= 0)
        {
          _.forEach(filters[column.value].filter.options, (option) => {
            if (option.text.toLowerCase() === 'managed') {
              option.text = "🛂Managed"
            } else if (option.text.toLowerCase() === 'diskless') {
              option.text = "⚡️Diskless"
            } else if (option.text.toLowerCase() === 'default') {
              option.text = "🟨Default"
            }
          })
        }

        if (column.value.toLowerCase() === 'state' && index >= 0) {
          _.forEach(filters[column.value].filter.options, (option) => {
            if (option.value === 'OK') {
              option.text = "🟢OK"
            } else if (option.value === 'poweredOn') {
              option.text = "🟢ON"
            } else if (option.value === 'NO PING') {
              option.text = "🔴NO PING"
            } else if (option.value === 'poweredOff') {
              option.text = "🔴OFF"
            } else if (option.value === 'UNKNOWN') {
              option.text = "🤷‍UNKNOWN"
            } else if (option.value === 'DESTROYED') {
              option.text = "🚫DESTROYED"
            } else if (option.value === 'CREATED') {
              option.text = "🚀CREATED"
            } else if (option.value === 'CHANGED') {
              option.text = "⚠️CHANGED"
            } else if (option.value === 'MOVE_PENDING') {
              option.text = "🔜MOVE_PENDING"
            } else if (option.value === 'suspended') {
              option.text = "⏸️SUSPENDED"
            } else if (option.value === null) {
              option.text = "0️⃣NULL"
            }
          })
        }
      })
      return filters
    },
    lastFilter: function () {
      let last = Object.keys(this.filterComputed)[Object.keys(this.filterComputed).length - 1]
      if (last === 'CRUD') {
        last = Object.keys(this.filterComputed)[Object.keys(this.filterComputed).length - 2]
      }
      return last
    }
  },
}
</script>

<style scoped>

</style>